module.exports = __webpack_public_path__ + "img/production2.ffcf05fd.png";